import { authorizedInstance } from "../config/axios"

export const getExperiments = async () => {
  const response = await authorizedInstance.get("/experiments")
  return response.data
}

export const createExperiment = async ({ name, startDate }) => {
  const response = await authorizedInstance.post("/experiments", {
    name,
    startDate,
  })
  return response.data
}

export const updateExperiment = async ({ id, isActive }) => {
  const response = await authorizedInstance.patch(`/experiments/${id}`, {
    isActive,
  })
  return response.data
}
